<template>
  <article class="layout-section -no-top layout-grid">
    <section v-for="(item, i) in wp.bullets" :key="item.title" class="layout-grid__item -third">
      <figure class="grid-bullet__figure" :class="modifiers[i]">
        <SvgIcon :id="icons[i]" />
      </figure>

      <h3 class="grid-bullet__title">{{ item.title }}</h3>
      <p>{{ item.text }}</p>
    </section>
  </article>
</template>

<script>
export default {
  name: 'RegisterBullets',
  inject: ['wp'],
  data() {
    return {
      icons: ['bullet-network', 'bullet-talk', 'bullet-card'],
      modifiers: ['-primary', '-accent']
    }
  }
}
</script>
